const SHOPPER_TIER = {
  BLACK: 1,
  GOLD: 2,
  SILVER: 3,
  BRONZE: 4
};

const SHOPPER_TIER_LABELS = {
  [SHOPPER_TIER.BLACK]: 'Black',
  [SHOPPER_TIER.GOLD]: 'Gold',
  [SHOPPER_TIER.SILVER]: 'Silver',
  [SHOPPER_TIER.BRONZE]: 'Bronze'
};

const SHOPPER_SPEND_MULTIPLIERS = Object.freeze({
  shopmy: 2,
  gmail: 1,
  plaid: 1
});

module.exports = {
  SHOPPER_TIER,
  SHOPPER_TIER_LABELS,
  SHOPPER_SPEND_MULTIPLIERS
};
